import * as tslib_1 from "tslib";
export function toImageSize(base64OrUrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var img;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!base64OrUrl) {
                        return [2 /*return*/, { width: 0, height: 0 }];
                    }
                    img = new Image();
                    return [4 /*yield*/, new Promise(function (resolve) {
                            img.src = base64OrUrl;
                            img.onload = function () { return resolve(null); };
                            img.onerror = function (error) {
                                console.error('Error loading image:', error);
                                resolve(null);
                            };
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {
                            width: img.width || 0,
                            height: img.height || 0
                        }];
            }
        });
    });
}
